var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "background",
    style: {
      'background-color': _vm.themeConfig.bg_color
    }
  }), _c('div', {
    staticClass: "container-scroller"
  }, [_c('div', {
    staticClass: "container-fluid page-body-wrapper full-page-wrapper"
  }, [_c('div', {
    staticClass: "\n          content-wrapper\n          d-flex\n          align-items-center\n          justify-content-center\n          auth\n          theme-one\n        "
  }, [_c('div', {
    staticClass: "row w-100"
  }, [_c('div', {
    staticClass: "col-lg-4 mx-auto"
  }, [_c('div', {
    staticClass: "auto-form-wrapper"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_vm.themeConfig.logo_url ? _c('div', {
    staticClass: "text-center mb-3"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.themeConfig.logo_url
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "text-center mb-3"
  }, [_c('h4', [_vm._v(_vm._s(_vm.organizationName) + " 管理後台")]), _c('div', {
    staticClass: "mb-2 h4 font-weight-normal mt-4"
  }, [_vm._v("請輸入認證碼")]), _vm.successDeliveryMessage ? _c('p', {
    staticClass: "text-success mb-2"
  }, [_vm._v(_vm._s(_vm.successDeliveryMessage))]) : _vm._e(), _c('p', [_vm._v("驗證碼將於 "), _c('span', {
    staticClass: "font-weight-bold mx-1",
    class: _vm.otpRemainingSeconds <= 60 ? 'text-danger' : 'text-primary'
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.otpRemainingSeconds)))]), _vm._v(" 後失效")])]), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('div', {
    staticClass: "form-group code-input"
  }, [_c('CodeInput', {
    ref: "codeInput",
    staticClass: "google-sans-code",
    attrs: {
      "loading": false,
      "fields": 6,
      "fieldHeight": 80
    },
    on: {
      "change": _vm.onCodeChange,
      "complete": _vm.onCodeComplete
    }
  })], 1), _c('div', {
    staticClass: "text-center mb-2"
  }, [_vm._v("收不到驗證碼？ "), _vm.resendRemainingSeconds <= 0 ? _c('a', {
    staticClass: "cursor-pointer font-weight-bold ml-1 text-primary",
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v("重新發送驗證碼")]) : _c('span', {
    staticClass: "text-muted ml-1"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.resendRemainingSeconds)) + "重新發送驗證碼")])]), _c('div', {
    staticClass: "text-center mb-4"
  }, [_c('router-link', {
    staticClass: "cursor-pointer",
    attrs: {
      "to": {
        name: 'AuthLogin',
        params: {
          org_code: _vm.$route.params.org_code
        }
      }
    }
  }, [_vm._v("返回重新登入")])], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary submit-btn btn-block",
    attrs: {
      "disabled": _vm.isSubmitting || _vm.otpRemainingSeconds <= 0
    }
  }, [_vm._v(" 送出 ")])])], 1)])], 1), _vm.footerText ? _c('p', {
    staticClass: "footer-text text-center"
  }, [_vm._v(" " + _vm._s(_vm.footerText) + " ")]) : _vm._e()])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }